import {ChangeDetectionStrategy, Component, Inject, Input, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {AviaCardBadgesComponent} from "./avia-card-badges/avia-card-badges.component";
import {AviaCardFlyComponent} from "./avia-card-fly/avia-card-fly.component";
import {PriceFormatPipe} from "../../../services/router/pipes/price-format.pipe";
import {AviaResultItineraries, AviaResultRoutPrice} from "../../../services/router/interfaces/avia-search";
import {pluralize} from "../../../components/pipes/pluralize/pluralize";
import {APP_CONFIG, AppConfig} from "../../../config/app.config";
import {WindowRefService} from "../../../services/window-ref.service";

@Component({
  selector: 'app-avia-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './avia-card.component.mobile.html',
  styleUrl: './avia-card.component.mobile.scss',
  imports: [
    AviaCardBadgesComponent,
    AviaCardFlyComponent,
    PriceFormatPipe,
    PriceFormatPipe
  ],
  standalone: true
})
export class AviaCardComponent implements OnInit{
  @Input() itinerary: AviaResultItineraries;
  @Input() isBestPrice: boolean;
  @Input() isShort: boolean = false;
  @Input() searchId?: string;

  constructor(
    @Inject(APP_CONFIG) private appConfig: AppConfig,
    private router: Router,
    private route: ActivatedRoute,
    private windowService: WindowRefService
  ) {
  }

  translations = this.appConfig.translates.aviaListing;

  price: AviaResultRoutPrice;
  seatInfo: string;

  ngOnInit(): void {
    this.price = this.itinerary.price;
  }

  goToDetails() {
    const baseUrl = this.appConfig.isPreview && this.searchId
      ? `/new/avia/details/${this.itinerary.id}/${this.searchId}`
      : `/new/avia/details/${this.itinerary.id}`;
    const queryParams = new URLSearchParams(this.route.snapshot.queryParams).toString();

    this.windowService.nativeWindow.showPageLoader();
    this.windowService.nativeWindow.location.href = queryParams ? `${baseUrl}?${queryParams}` : baseUrl;
  }

  get isShowSeatInfo() {
    let minSeatsLeft = 0;
    let selectedSeatInfo = '';

    for (const leg of this.itinerary.legs) {
      for (const segment of leg.segments) {
        const availability = segment.seatAvailability;
        if (availability?.status === 'few_left') {
          if (typeof availability.seatsLeft === 'number') {
            if (availability.seatsLeft > minSeatsLeft) {
              minSeatsLeft = availability.seatsLeft;
              const str = pluralize(availability.seatsLeft, this.translations.pluralPlace);
              selectedSeatInfo = `${this.translations.left} ${availability.seatsLeft} ${str}`;
            }
          } else {
            // Если нет числа, но раньше не было лучшего варианта
            selectedSeatInfo = this.translations.fewPlace;
          }
        }
      }
    }

    if (selectedSeatInfo) {
      this.seatInfo = selectedSeatInfo;
      return true;
    }

    return false;
  }

}
